import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { Call } from '@twilio/voice-sdk'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { AccordionSection } from 'widgets/CallPopUp/ui/components/AccordionSection/AccordionSection'
import { useCallPopUpDefaultContext } from 'widgets/CallPopUp/context/callPopUpDefaultContext'
import { CallInsightCardsTabs } from 'widgets/CallPopUp/ui/CallInsightCards/CallInsightCardsTabs'
import { CallInsightCardsDetails } from 'widgets/CallPopUp/ui/CallInsightCards/CallInsightCardsDetails'
import { CallInsightCardsNote } from 'widgets/CallPopUp/ui/CallInsightCards/CallInsightCardsNote'
import { CallInsightCardsHeader } from 'widgets/CallPopUp/ui/CallInsightCards/CallInsightCardsHeader/CallInsightCardsHeader'
import styles from './styles.module.scss'

export const CallInsightCardsContent = observer(() => {
  const { callPopUpInsightCardsStore, contactFrom, status, wasCallAnswered } =
    useCallPopUpDefaultContext()
  const { organizationStore } = useEntitiesContext()
  const {
    note,
    details,
    isViewAll,
    isShowContent,
    toggleShowContent,
    setCallTypeModalState,
    callNoteStore,
    contact,
  } = callPopUpInsightCardsStore

  const handleCollapse = () => {
    toggleShowContent()
  }

  useEffect(() => {
    if (contact?.isSyncedWithHubspot && status === Call.State.Open) {
      setCallTypeModalState(true)
    }
  }, [contact?.isSyncedWithHubspot, status])

  useEffect(() => {
    return () => {
      callNoteStore.handleMessageSend()
    }
  }, [])

  useEffect(() => {
    if (organizationStore.isActivityLoggingEnabled && isShowContent && contactFrom) {
      if (details) {
        organizationStore.handleTrackOrganizationActivity({
          event: 'phi.contact.viewed',
          data: {
            contact_id: contactFrom?.id,
          },
        })
      }
    }
  }, [isShowContent, details, organizationStore.isActivityLoggingEnabled])

  if (!contactFrom || !wasCallAnswered) return null

  const renderCustomHeader = () => {
    if (isViewAll) {
      return <CallInsightCardsHeader />
    }

    return null
  }

  return (
    <AccordionSection
      show={isShowContent}
      fullWidthRight
      showIconButton
      headerStyles={{ padding: '10px 16px 10px 10px' }}
      renderButton={
        <CallInsightCardsTabs
          callBack={() => {
            if (!isShowContent) toggleShowContent()
          }}
        />
      }
      renderCustomHeader={renderCustomHeader()}
      callBackCollapse={handleCollapse}
    >
      <div className={styles.content}>
        {details && <CallInsightCardsDetails />}
        {note && <CallInsightCardsNote />}
      </div>
    </AccordionSection>
  )
})
